import {Injectable} from '@angular/core';
import {InternationalizationService} from './internationalization.service';

@Injectable()
export class ConfigurationService {
	public brightCities = ' - Bright Cities';

	public keyTitle = {
		'featuredIn': {
			title: ''
		}, 'location': {
			title: ''
		}, 'technology': {
			title: ''
		}, 'orderBy': {
			title: ''
		}, 'population': {
			title: ''
		}, 'estimatedInvestment': {
			title: ''
		}, 'tags': {
			title: ''
		}, 'areas': {
			title: ''
		}
	};

	public labelAreas = {
		'configuration/ENVIRONMENT': {
			name: 'Environment',
			value: 'ENVIRONMENT'
		},
		'configuration/ENERGY': {
			name: 'Energy',
			value: 'ENERGY'
		},
		'configuration/GOVERNANCE': {
			name: 'Governance',
			value: 'GOVERNANCE'
		},
		'configuration/HEALTH': {
			name: 'Health',
			value: 'HEALTH'
		},
		'configuration/SECURITY': {
			name: 'Security',
			value: 'SECURITY'
		},
		'configuration/ECONOMY': {
			name: 'Economy',
			value: 'ECONOMY'
		},
		'configuration/TECHNOLOGY': {
			name: 'Technology',
			value: 'TECHNOLOGY'
		},
		'configuration/EDUCATION': {
			name: 'Education',
			value: 'EDUCATION'
		},
		'configuration/MOBILITY': {
			name: 'Mobility',
			value: 'MOBILITY'
		},
		'configuration/URBANISM': {
			name: 'Urbanism',
			value: 'URBANISM'
		}
	};

	public labelCityColumns = {
		'painel-dashboard/city': {
			slug: 'name',
			order: true,
			title: 'CITY'
		},
		'painel-dashboard/region': {
			slug: 'region',
			order: true,
			title: 'REGION'
		},
		'painel-dashboard/country': {
			slug: 'country',
			order: true,
			title: 'COUNTRY'
		},
		'painel-dashboard/completed-data': {
			slug: 'completedData',
			order: false,
			title: 'COMPLETED DATA'
		},
		'painel-dashboard/score': {
			slug: 'generalScore',
			order: true,
			title: 'SCORE'
		},
		'configuration/ENVIRONMENT': {
			slug: 'ENVIRONMENT',
			order: true,
			title: 'ENVIRONMENT',
			icon: 'meioAmbiente'
		},
		'configuration/ENERGY': {
			slug: 'ENERGY',
			order: true,
			title: 'ENERGY',
			icon: 'energia'
		},
		'configuration/GOVERNANCE': {
			slug: 'GOVERNANCE',
			order: true,
			title: 'GOVERNANCE',
			icon: 'governanca'
		},
		'configuration/HEALTH': {
			slug: 'HEALTH',
			order: true,
			title: 'HEALTH',
			icon: 'saude'
		},
		'configuration/SECURITY': {
			slug: 'SECURITY',
			order: true,
			title: 'SECURITY',
			icon: 'seguranca'
		},
		'configuration/ECONOMY': {
			slug: 'ECONOMY',
			order: true,
			title: 'ECONOMY',
			icon: 'economia'
		},
		'configuration/TECHNOLOGY': {
			slug: 'TECHNOLOGY',
			order: true,
			title: 'TECHNOLOGY',
			icon: 'tecnologiaInovacao'
		},
		'configuration/EDUCATION': {
			slug: 'EDUCATION',
			order: true,
			title: 'EDUCATION',
			icon: 'educacao'
		},
		'configuration/MOBILITY': {
			slug: 'MOBILITY',
			order: true,
			title: 'MOBILITY',
			icon: 'mobilidade'
		},
		'configuration/URBANISM': {
			slug: 'URBANISM',
			order: true,
			title: 'URBANISM',
			icon: 'urbanismo'
		},
		'configuration/updated-on': {
			order: true,
			title: 'UPDATE ON'
		}
	};

	public labelSolutionColumns = {
		'painel-dashboard/solution': {
			slug: 'name',
			order: true,
			title: 'SOLUTION'
		},
		'painel-dashboard/provided-by': {
			slug: 'supplierName',
			order: true,
			title: 'PROVIDED BY'
		},
		'painel-dashboard/impact': {
			slug: 'impact',
			order: true,
			title: 'IMPACT'
		},
		'painel-dashboard/time': {
			slug: 'deliveryTime',
			order: true,
			title: 'TIME'
		},
		'painel-dashboard/cost': {
			slug: 'cost',
			order: true,
			title: 'COST'
		},
		'painel-dashboard/applied-cities': {
			slug: 'numCitiesApplied',
			order: true,
			title: 'APPLIED IN CITIES'
		},
		'painel-dashboard/updated-at': {
			slug: 'updatedAt',
			order: true,
			title: 'UPDATE ON'
		}
	};

	public labelSupplierColumns = {
		'painel-dashboard/name': {
			slug: 'name',
			order: true,
			title: 'Name'
		},
		'painel-dashboard/country': {
			slug: 'country',
			order: true,
			title: 'Country'
		},
		'painel-dashboard/region': {
			slug: 'region',
			order: true,
			title: 'Region'
		},
		'painel-dashboard/host-city': {
			slug: 'city',
			order: true,
			title: 'HOST CITY'
		},
		'painel-dashboard/employees': {
			slug: 'numEmployees',
			order: true,
			title: 'Employees'
		},
		'painel-dashboard/solutions': {
			slug: 'numSolutions',
			order: true,
			title: 'SOLUTIONS'
		},
		'painel-dashboard/updated-on': {
			slug: 'updatedAt',
			order: true,
			title: 'UPDATE ON'
		}
	};

	public labelUserColumns = {
		'painel-dashboard/name': {
			slug: 'name',
			order: true,
			title: 'Name'
		},
		'create-account/email': {
			slug: 'email',
			order: true,
			title: 'Email'
		},
		'painel-dashboard/type': {
			slug: 'type',
			order: true,
			title: 'TYPE'
		},
		'create-account/city': {
			slug: 'city',
			order: false,
			title: 'CITY'
		},
		// "painel-dashboard/status": {
		//     slug: 'status',
		//     order: false,
		//     title: 'STATUS'
		// },
		'painel-dashboard/created-at': {
			slug: 'createdAt',
			order: true,
			title: 'CREATED AT'
		}
	};

	public labelAccountColumns = {
		'painel-dashboard/account': {
			slug: 'account',
			order: true,
			title: 'Account'
		},
		'painel-dashboard/city': {
			slug: 'city',
			order: true,
			title: 'City'
		},
		'painel-dashboard/type': {
			slug: 'type',
			order: true,
			title: 'TYPE'
		},
		'account-details/plan': {
			slug: 'plan',
			order: false,
			title: 'Plan'
		},
		'navigation/users': {
			slug: 'users',
			order: false,
			title: 'Users'
		},
		'painel-dashboard/status': {
			slug: 'status',
			order: false,
			title: 'Status'
		},
		'painel-dashboard/registered': {
			slug: 'registered',
			order: false,
			title: 'Registered'
		},
		'painel-dashboard/email-verified': {
			slug: 'emailVerified',
			order: false,
			title: 'E-mail Verified'
		},
		'painel-dashboard/last-visited': {
			slug: 'lastAccess',
			order: true,
			title: 'Last Visited'
		},
		'painel-dashboard/created-at': {
			slug: 'createdAt',
			order: true,
			title: 'Created At'
		}
	}

	public labelAccountUser = {
		'create-account/account': {
			slug: 'account',
			order: true,
			title: 'Account'
		},
		'painel-dashboard/phone': {
			slug: 'phone',
			order: true,
			title: 'Phone'
		},
		'painel-dashboard/role': {
			slug: 'role',
			order: true,
			title: 'Role'
		},
		'painel-dashboard/permissions': {
			slug: 'permissions',
			order: true,
			title: 'Permissions'
		},
		'painel-dashboard/registered': {
			slug: 'registered',
			order: false,
			title: 'Registered'
		},
		'painel-dashboard/email-verified': {
			slug: 'emailVerified',
			order: false,
			title: 'E-mail Verified'
		},
		'painel-dashboard/last-visited': {
			slug: 'lastAccess',
			order: true,
			title: 'Last Visited'
		},
		'painel-dashboard/created-at': {
			slug: 'createdAt',
			order: true,
			title: 'Created At'
		}
	}

	public labelIndicatorsColumns = {
		'painel-dashboard/name': {
			slug: 'name',
			order: true,
			title: 'NAME'
		},
		'painel-dashboard/unity': {
			slug: 'unity',
			order: true,
			title: 'UNITY'
		},
		'painel-dashboard/areas': {
			slug: 'areas',
			order: true,
			title: 'AREAS'
		},
		'painel-dashboard/goal': {
			slug: 'goal',
			order: true,
			title: 'GOAL'
		},
		'painel-dashboard/indicator-reference': {
			slug: 'reference',
			order: true,
			title: 'REFERENCE'
		},
		'painel-dashboard/updated-on': {
			slug: 'updatedAt',
			order: true,
			title: 'UPDATE ON'
		}
	};

	public labelOpportunitiesColumns = {
		'painel-dashboard/city': {
			slug: 'name',
			order: true,
			title: 'CITY'
		},
		'configuration/region': {
			slug: 'region',
			order: true,
			title: 'Region'
		},
		'configuration/population': {
			slug: 'population',
			order: true,
			title: 'POPULATION'
		},
		'configuration/opportunities-improvement-index': {
			slug: 'opportunityDegree',
			order: true,
			title: 'OPPORTUNITIES IMPROVEMENT INDEX'
		},
		'configuration/impacted-indicators': {
			slug: 'impacted-indicators',
			order: false,
			title: 'IMPACTED INDICATORS'
		}

	};

	public labelLanguageColumns = {
		'painel-dashboard/languages': {
			slug: 'title',
			order: true,
			title: 'LANGUAGE'
		},
		'painel-dashboard/country': {
			slug: 'flag',
			order: true,
			title: 'COUNTRY'
		},
		'painel-dashboard/created-on': {
			slug: 'createdOn',
			order: true,
			title: 'CREATED ON'
		},
		'painel-dashboard/updated-on': {
			slug: 'updatedAt',
			order: true,
			title: 'UPDATE ON'
		}
	};

	public userProfileList = {
		'CITIZEN': {
			key: 'create-account/CITIZEN',
			name: ''
		},
		'PUBLIC_ADMINISTRATOR': {
			key: 'create-account/PUBLIC_ADMINISTRATOR',
			name: ''
		},
		'SOLUTION_PROVIDER': {
			key: 'create-account/SOLUTION_PROVIDER',
			name: ''
		}
	};
	public implantationTimeRange = {
		'0': {
			key: 'painel-dashboard/implantation-time-range-0',
			text: 'até 6 meses'
		},
		'1': {
			key: 'painel-dashboard/implantation-time-range-1',
			text: 'até 6 meses'
		},
		'2': {
			key: 'painel-dashboard/implantation-time-range-2',
			text: 'de 6 meses a 1 ano'
		},
		'3': {
			key: 'painel-dashboard/implantation-time-range-3',
			text: 'de 1 a 2 anos'
		},
		'4': {
			key: 'painel-dashboard/implantation-time-range-4',
			text: 'de 2 a 5 anos'
		},
		'5': {
			key: 'painel-dashboard/implantation-time-range-5',
			text: 'mais de 5 anos'
		}
	};
	public implantationCostRange = {
		'0': {
			key: 'painel-dashboard/implantation-cost-range-0',
		},
		'1': {
			key: 'painel-dashboard/implantation-cost-range-1',
		},
		'2': {
			key: 'painel-dashboard/implantation-cost-range-2',
		},
		'3': {
			key: 'painel-dashboard/implantation-cost-range-3',
		},
		'4': {
			key: 'painel-dashboard/implantation-cost-range-4',
		},
		'5': {
			key: 'painel-dashboard/implantation-cost-range-5',
		}
	};
	public implantationImpactRange = {
		'0': {
			key: 'painel-dashboard/implantation-impact-range-0',
		},
		'1': {
			key: 'painel-dashboard/implantation-impact-range-1',
		},
		'2': {
			key: 'painel-dashboard/implantation-impact-range-2',
		},
		'3': {
			key: 'painel-dashboard/implantation-impact-range-3',
		},
		'4': {
			key: 'painel-dashboard/implantation-impact-range-4',
		},
		'5': {
			key: 'painel-dashboard/implantation-impact-range-5',
		}
	};
	private _validation = [
		{
			name: 'POSITIVE_DOUBLE',
			slug: 'POSITIVE_DOUBLE'
		},
		{
			name: 'POSITIVE_NUMBER',
			slug: 'POSITIVE_NUMBER'
		},
		{
			name: 'DOUBLE_BETWEEN_ZERO_ONE',
			slug: 'DOUBLE_BETWEEN_ZERO_ONE'
		},
		{
			name: 'POSITIVE_FLOAT',
			slug: 'POSITIVE_FLOAT'
		},
		{
			name: 'ZERO_ONE',
			slug: 'ZERO_ONE'
		},
		{
			name: 'PERCENTAGE_POSITIVE_DOUBLE',
			slug: 'PERCENTAGE_POSITIVE_DOUBLE'
		},
		{
			name: 'PERCENTAGE_POSITIVE_FLOAT',
			slug: 'PERCENTAGE_POSITIVE_FLOAT'
		},
		{
			name: 'MONETARY_VALUE',
			slug: 'MONETARY_VALUE'
		},
		{
			name: 'NUMBER_LOWER_100',
			slug: 'NUMBER_LOWER_100'
		},
		{
			name: 'NEGATIVE_DOUBLE',
			slug: 'NEGATIVE_DOUBLE'
		},
		{
			name: 'NEGATIVE_FLOAT',
			slug: 'NEGATIVE_FLOAT'
		},
		{
			name: 'NEGATIVE_NUMBER',
			slug: 'NEGATIVE_NUMBER'
		},
		{
			name: 'NUMBER_BETWEEN_MINUS100_AND_100',
			slug: 'NUMBER_BETWEEN_MINUS100_AND_100'
		},
		{
			name: 'FLOAT_VALUE',
			slug: 'FLOAT_VALUE'
		}
	];
	private _subArea = [
		{name: 'ACCESS_TO_EDUCATION', slug: 'ACCESS_TO_EDUCATION'},
		{name: 'AIR_POLLUTION', slug: 'AIR_POLLUTION'},
		{name: 'BUSINESS_ENVIRONMENT', slug: 'BUSINESS_ENVIRONMENT'},
		{name: 'CITIZEN_PARTICIPATION', slug: 'CITIZEN_PARTICIPATION'},
		{name: 'COMMUNICATION_TECHNOLOGIES', slug: 'COMMUNICATION_TECHNOLOGIES'},
		{name: 'CONNECTIVITY_INFRASTRUCTURE', slug: 'CONNECTIVITY_INFRASTRUCTURE'},
		{name: 'CRIMINALITY', slug: 'CRIMINALITY'},
		{name: 'DISASTER_MANAGEMENT', slug: 'DISASTER_MANAGEMENT'},
		{name: 'EASE_OF_ENTREPRENEURSHIP', slug: 'EASE_OF_ENTREPRENEURSHIP'},
		{name: 'ECONOMY_AND_SOCIAL_CONDITIONS', slug: 'ECONOMY_AND_SOCIAL_CONDITIONS'},
		{name: 'ELECTRIC_POWER_CONSUMPTION', slug: 'ELECTRIC_POWER_CONSUMPTION'},
		{name: 'ELECTRICITY_INFRASTRUCTURE', slug: 'ELECTRICITY_INFRASTRUCTURE'},
		{name: 'EMPLOYMENT_AND_INCOME', slug: 'EMPLOYMENT_AND_INCOME'},
		{name: 'GENERAL_INFORMATION', slug: 'GENERAL_INFORMATION'},
		{name: 'INFRASTRUCTURE_AND_HUMAN_RESOURCES', slug: 'INFRASTRUCTURE_AND_HUMAN_RESOURCES'},
		{name: 'INNOVATION', slug: 'INNOVATION'},
		{name: 'LEISURE_AND_GREEN_AREA', slug: 'LEISURE_AND_GREEN_AREA'},
		{name: 'MORTALITY', slug: 'MORTALITY'},
		{name: 'PUBLIC_FINANCES', slug: 'PUBLIC_FINANCES'},
		{name: 'PUBLIC_TRANSPORTATION', slug: 'PUBLIC_TRANSPORTATION'},
		{name: 'RAINWATER_MANAGEMENT', slug: 'RAINWATER_MANAGEMENT'},
		{name: 'SCHOOL_SURVIVAL_RATE', slug: 'SCHOOL_SURVIVAL_RATE'},
		{name: 'SOLID_WASTE', slug: 'SOLID_WASTE'},
		{name: 'SUSTAINABLE_MOBILITY', slug: 'SUSTAINABLE_MOBILITY'},
		{name: 'TEACHING_INFRASTRUCTURE', slug: 'TEACHING_INFRASTRUCTURE'},
		{name: 'URBAN_PLANNING', slug: 'URBAN_PLANNING'},
		{name: 'WATER_AND_SANITATION', slug: 'WATER_AND_SANITATION'},
		{name: 'WATER_SUPPLY', slug: 'WATER_SUPPLY'},
		{name: 'SUSTAINABILITY', slug: 'SUSTAINABILITY'},
		{name: 'ENTREPRENEURSHIP', slug: 'ENTREPRENEURSHIP'},
		{name: 'SOCIOECONOMIC_DEVELOPMENT', slug: 'SOCIOECONOMIC_DEVELOPMENT'}
	];

	constructor(
		private internationalizationService: InternationalizationService) {

		let keysConfig = Object.keys(this.keyTitle);
		keysConfig.forEach(element => {
			this.internationalizationService.translate.get('configuration/' + element).subscribe((text: string) => {

				this.keyTitle[element].title = text;
			});
		});


		let keysCityColumns = Object.keys(this.labelCityColumns);
		keysCityColumns.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {

				this.labelCityColumns[element].title = text;
			});
		});


		let keysSolutionColumns = Object.keys(this.labelSolutionColumns);
		keysSolutionColumns.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {

				this.labelSolutionColumns[element].title = text;
			});
		});

		let keysSupplierColumns = Object.keys(this.labelSupplierColumns);
		keysSupplierColumns.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {

				this.labelSupplierColumns[element].title = text;
			});
		});

		let keysIndicatorsColumns = Object.keys(this.labelIndicatorsColumns);
		keysIndicatorsColumns.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {
				this.labelIndicatorsColumns[element].title = text;
			});
		});


		let keysOpportunitiesColumns = Object.keys(this.labelOpportunitiesColumns);
		keysOpportunitiesColumns.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {
				this.labelOpportunitiesColumns[element].title = text;
			});
		});

		let keysAreas = Object.keys(this.labelAreas);
		keysAreas.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {
				this.labelAreas[element].name = text;
			});
		});

		let keysLanguages = Object.keys(this.labelLanguageColumns);
		keysLanguages.forEach(element => {
			this.internationalizationService.translate.get(element).subscribe((text: string) => {
				this.labelLanguageColumns[element].title = text;
			});
		});

		let keysProfile = Object.keys(this.userProfileList);
		keysProfile.forEach(element => {
			this.internationalizationService.translate.get(this.userProfileList[element].key).subscribe((text: string) => {
				this.userProfileList[element].name = text;
			});
		});

		this._validation.forEach(element => {
			this.internationalizationService.translate.get('validation/' + element.slug).subscribe((text: string) => {
				element.name = text;
			});
		});
		this._subArea.forEach(element => {
			this.internationalizationService.translate.get('painel-indicators/' + element.slug).subscribe((text: string) => {
				element.name = text;
			});
		});
	}

	get globalName() {
		return this.titleName('teste');
	}

	titleName(name: string): string {
		return name;
	}

	getFilterTitle(filter: string): string {
		return this.keyTitle[filter].title;
	}

	getIcon(name: string): string {
		let title: string;

		switch (name) {
			case 'ENVIRONMENT':
				title = 'meioAmbiente';
				break;
			case 'ENERGY':
				title = 'energia';
				break;
			case 'GOVERNANCE':
				title = 'governanca';
				break;
			case 'HEALTH':
				title = 'saude';
				break;
			case 'SECURITY':
				title = 'seguranca';
				break;
			case 'ECONOMY':
				title = 'economia';
				break;
			case 'TECHNOLOGY':
				title = 'tecnologiaInovacao';
				break;
			case 'EDUCATION':
				title = 'educacao';
				break;
			case 'MOBILITY':
				title = 'mobilidade';
				break;
			case 'URBANISM':
				title = 'urbanismo';
				break;
		}
		return title;
	}

	limitString(s: string, n: any): string {
		if (s) {
			const string = s.indexOf(' ', n);
			if (string === -1) {
				return s;
			} else {
				return s.substring(0, string) + ' ...';
			}
		}
	}

	getEmployeeQuantity(): Array<any> {
		return [
			{
				slug: 'ZERO_TO_ONE',
				title: '0 - 1'
			},
			{
				slug: 'TWO_TO_TEN',
				title: '2 - 10'
			},
			{
				slug: 'ELEVEN_TO_FIFTY',
				title: '11 - 50'
			},
			{
				slug: 'FIFTY_ONE_TO_TWO_HUNDRED',
				title: '51 - 200'
			},
			{
				slug: 'TWO_HUNDRED_AND_ONE_TO_FIVE_HUNDRED',
				title: '201 - 500'
			},
			{
				slug: 'FIVE_HUNDRED_AND_ONE_TO_ONE_THOUSAND',
				title: '501 - 1.000'
			},
			{
				slug: 'ONE_THOUSAND_AND_ONE_TO_FIVE_THOUSAND',
				title: '1.001 - 5.000'
			},
			{
				slug: 'FIVE_THOUSAND_TO_TEN_THOUSAND',
				title: '5.001 - 10.000'
			},
			{
				slug: 'MORE_THAN_TEN_THOUSAND',
				title: '10.000 +'
			}
		];
	}

	getSubAreas(): Array<any> {
		return this._subArea;
	}

	getCityInfoProfile(): Array<any> {
		let cityInfoProfile =
			[{
				title: 'Annual inflation rate (average last 5 years)',
				slug: 'annualInflationRate',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Annual population change',
				slug: 'annualPopulationChange',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Average household income',
				slug: 'averageHouseholdIncome',
				label: 'USD',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'City Gross Capital Budget',
				slug: 'cityGrossCapitalBudget',
				label: 'USD',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'City Gross Domestic Product',
				slug: 'cityGrossDomesticProduct',
				label: 'USD',
				labelKey: 'painel-dashboard/label-billionusd',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'City Gross Operating Budget',
				slug: 'cityGrossOperatingBudget',
				label: 'USD',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'City product as percent of country GDP',
				slug: 'cityProductAsPercentOfCountryGDP',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'Country GDP per capita',
				slug: 'countryGDPPerCapita',
				label: 'USD',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'Country Gross Domestic Product',
				slug: 'countryGrossDomesticProduct',
				label: 'USD',
				labelKey: 'painel-dashboard/label-billionusd',
				validation: 'MONETARY_VALUE'
			}, {
				title: 'Dwelling density',
				slug: 'dwellingDensity',
				labelKey: 'painel-dashboard/label-reskm2',
				validation: 'POSITIVE_FLOAT'
			}, {
				title: 'Employment Annual Percent Change',
				slug: 'employmentAnnualPercentChange',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'General Score - Bright Cities',
				slug: 'generalScore',
				validation: 'POSITIVE_DOUBLE'
			}, {
				title: 'Gini coefficient',
				slug: 'giniCoefficient',
				label: 'Value between 0 and 1',
				labelKey: 'painel-dashboard/label-between0-1',
				validation: 'DOUBLE_BETWEEN_ZERO_ONE'
			}, {
				title: 'City land area',
				slug: 'landArea',
				label: 'km²',
				labelKey: 'painel-dashboard/label-km2',
				validation: 'POSITIVE_DOUBLE'
			}, {
				title: 'Male to femal ratio',
				slug: 'maleToFemalRatio',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percent of population children aged 0 - 14',
				slug: 'percentOfPopulationChildrenAged0To14',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percent of population adult aged 25 - 64',
				slug: 'percentOfPopulationAdultAged25To64',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percent of population foreign born',
				slug: 'percentOfPopulationForeignBorn',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percent of population new immigrants',
				slug: 'percentOfPopulationNewImmigrants',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percent of population non citizens',
				slug: 'percentOfPopulationNonCitizens',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percentage of population that are seniors (aged 65+)',
				slug: 'percentOfPopulationSeniorAgedOver65',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percentage of population that are youths (aged 15-24)',
				slug: 'percentOfPopulationYouthAged15_24',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Percentage of country population',
				slug: 'percentageOfCountryPopulation',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'People per unit',
				slug: 'personsPerUnit',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Population density',
				slug: 'populationDensity',
				label: 'hab./km²',
				labelKey: 'painel-dashboard/label-habkm2',
				validation: 'POSITIVE_FLOAT'
			}, {
				title: 'Population dependency ratio',
				slug: 'populationDependencyRatio',
				validation: 'POSITIVE_FLOAT'
			}, {
				title: 'Population poverty percentage',
				slug: 'populationPovertyPercentage',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}, {
				title: 'Total number of household',
				slug: 'totalNumberOfHouseholds',
				validation: 'POSITIVE_NUMBER'
			}, {
				title: 'Total number of dwelling units',
				slug: 'totalNumberOfOccupiedDwellingUnits',
				validation: 'POSITIVE_NUMBER'
			}, {
				title: 'Total City Population',
				slug: 'totalPopulation',
				validation: 'POSITIVE_FLOAT'
			}, {
				title: 'City´s uneployment rate',
				slug: 'unemploymentRate',
				label: '%',
				validation: 'PERCENTAGE_POSITIVE_FLOAT'
			}];

		cityInfoProfile.forEach(element => {
			this.internationalizationService.translate.get('city-profile/' + element.slug).subscribe((text: string) => {
				element.title = text;
			});
		});


		return cityInfoProfile;
	}

	getCompanyType(): Array<any> {
		let companyType =
			[{
				value: 'PUBLIC_CAPITAL',
				title: ''
			}, {
				value: 'PRIVATE_CAPITAL',
				title: ''
			}, {
				value: 'OPEN_CAPITAL',
				title: ''
			}, {
				value: 'INDIVIDUAL',
				title: ''
			}, {
				value: 'EDUCATION_INSTITUTION',
				title: ''
			}, {
				value: 'GOVERNMENT',
				title: ''
			}, {
				value: 'NON_PROFIT',
				title: ''
			}, {
				value: 'ASSOCIATION',
				title: ''
			},];

		// companyType.forEach(element => {
		//     this.internationalizationService.translate.get('configuration/companytype-' + element.value).subscribe((text: string) => {
		//         element.title = text;
		//     });
		// });

		return companyType;
	}

	getAreas(): Array<any> {
		let keys = Object.keys(this.labelAreas);
		let arr: Array<any> = [];

		for (let key of keys) {
			arr.push(this.labelAreas[key]);
		}
		return arr;
	}

	getValidation(): Array<any> {
		return this._validation;
	}
}
